<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__financial_title')}}</h4>
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__audit')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__audit_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.audit === row.value}" v-for="(row, index) in tableAudit" :key="index">
                <td>
                  <radio name="model.audit"
                         :value="row.value"
                         v-model="EvaluationForm.model.audit"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.audit}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_audit" :comments="EvaluationForm.model.comments_audit"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__anual_financial_statements')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__anual_financial_statements')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.financial_statements === row.value}" v-for="(row, index) in tableFinancialStatements" :key="index">
                <td>
                  <radio name="model.financial_statements"
                         :value="row.value"
                         v-model="EvaluationForm.model.financial_statements"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.financial_statements}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_financial_statement" :comments="EvaluationForm.model.comments_financial_statement"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__financial_principles')}}</h5>
            <h5 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__financial_principles_i')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__financial_sistems')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.financial_principles === row.value}" v-for="(row, index) in tableFinancialPrinciples" :key="index">
                <td>
                  <radio name="model.financial_principles"
                         :value="row.value"
                         v-model="EvaluationForm.model.financial_principles"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.financial_principles}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_financial_systems" :comments="EvaluationForm.model.comments_financial_systems"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold mt-3 mb-0">{{$t('medium_grant_ev.diligence__financial_principles_ii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__tracking_income_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.financial_principles_ii === row.value}" v-for="(row, index) in tableFinancialPrinciplesIi" :key="index">
                <td>
                  <radio name="model.financial_principles_ii"
                         :value="row.value"
                         v-model="EvaluationForm.model.financial_principles_ii"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.financial_principles_ii}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_financial_principles" :comments="EvaluationForm.model.comments_financial_principles"></comment-box>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        tableAudit: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_anual_audit')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_no_anual_audit')},
        ],
        tableFinancialStatements: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_anual_financial_stm_av')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_anual_financial_stm')},
          {'value': 8, 'text': this.$i18n.t('medium_grant_ev.diligence__table_anual_financial_stm_na')},
        ],
        tableFinancialPrinciples: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_financial_0')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_financial_4')},
        ],
        tableFinancialPrinciplesIi: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_financial_ii_0')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_financial_ii_4')},
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>